import { Text, View } from 'react-native'
import { ArrowRight, MapPin, Sparkles } from '@/components/ui/icons'
import { Pressable } from '@/components/ui/Pressable'
import { useTheme } from '@/lib/hooks/use-theme'
import { COLORS, FONTS, RADIUS, SPACING } from '@/lib/brand'
import { INTERACTION, useSemanticColors } from '@/lib/theme/tokens'
import { useTranslation } from 'react-i18next'

/** A compact, high-intent alternative when the catalog route is not the trip. */
export function TourCustomQuoteCta({ onPress }: { onPress: () => void }) {
  const { t } = useTranslation()
  const { isDark } = useTheme()
  const colors = useSemanticColors(isDark)

  return (
    <Pressable
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel={t('tours.custom_quote.cta_title')}
      testID="tours.custom-quote-cta"
      style={({ pressed }) => ({
        minHeight: INTERACTION.minTouchTarget,
        borderRadius: RADIUS.xl,
        borderWidth: 1,
        borderColor: isDark ? 'rgba(255,255,255,0.12)' : 'rgba(91,84,144,0.16)',
        backgroundColor: isDark ? 'rgba(91,84,144,0.18)' : 'rgba(91,84,144,0.055)',
        padding: SPACING.md,
        flexDirection: 'row',
        alignItems: 'center',
        gap: SPACING.sm,
        opacity: pressed ? 0.9 : 1,
        transform: [{ scale: pressed ? 0.99 : 1 }],
      })}
    >
      <View
        style={{
          width: 42,
          height: 42,
          borderRadius: 21,
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: COLORS.coral.DEFAULT,
        }}
      >
        <MapPin size={20} color={COLORS.white} strokeWidth={2.15} />
      </View>
      <View style={{ flex: 1, minWidth: 0 }}>
        <View style={{ flexDirection: 'row', alignItems: 'center', gap: 5 }}>
          <Text
            style={{ fontFamily: FONTS.bodyBold, fontSize: 16, color: colors.textPrimary }}
            numberOfLines={1}
          >
            {t('tours.custom_quote.cta_title')}
          </Text>
          <Sparkles size={15} color={COLORS.amber.DEFAULT} strokeWidth={2} />
        </View>
        <Text
          style={{
            marginTop: 2,
            fontFamily: FONTS.body,
            fontSize: 13,
            color: colors.textSecondary,
          }}
          numberOfLines={2}
        >
          {t('tours.custom_quote.cta_body')}
        </Text>
      </View>
      <View
        style={{
          width: 32,
          height: 32,
          borderRadius: 16,
          backgroundColor: colors.surface,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <ArrowRight size={17} color={COLORS.coral.DEFAULT} strokeWidth={2.3} />
      </View>
    </Pressable>
  )
}
